import { forwardRef, useEffect, useRef, useState } from "react";

/*eslint-disable */

declare const window: any;

interface DiseñoVehiculosComponentProps {
  diseño: any;
}

const DiseñoVehiculosComponent = forwardRef<HTMLDivElement, DiseñoVehiculosComponentProps>(
  ({ diseño }, ref) => {
    const [visibleItems, setVisibleItems] = useState<number[]>([]); // Trackear los elementos visibles
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [scrollPosition, setScrollPosition] = useState(0);

    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };

    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = parseInt(entry.target.getAttribute("data-index") || "");

            if (entry.isIntersecting) {
              setVisibleItems((prev) => [...prev, index]);
            } else if (entry.boundingClientRect.top > 0) {
              setVisibleItems((prev) => prev.filter((item) => item !== index));
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      // Asegurarte de que los refs estén listos antes de observar con un timeout
      const timeoutId = setTimeout(() => {
        itemRefs.current.forEach((ref) => {
          if (ref) {
            observer.observe(ref);
          }
        });
      }, 100); // Ajusta este valor según lo que funcione mejor en tu entorno

      // Limpieza del observer cuando el componente se desmonta
      return () => {
        clearTimeout(timeoutId);
        itemRefs.current.forEach((ref) => {
          if (ref) {
            observer.unobserve(ref);
          }
        });
      };
    }, [diseño]);

    return (
      <div className="diseño-vehiculos-detail-component" ref={ref}>
        <div className="title-diseño-vehiculos-detail-component">
          {diseño?.title}
        </div>
        {diseño?.contenido?.map((item: any, index: number) => (
          <div
            ref={(el) => (itemRefs.current[index] = el)}
            data-index={index}
            className={`${item?.format !== "wide" ? "small-diseño-vehiculos-detail-component" : "large-diseño-vehiculos-detail-component"} ${item.format} ${visibleItems.includes(index) ? "visible" : ""}`}
            key={index}
          >
            <div className={item.format !== "wide" ? `asset-small-diseño-vehiculos-detail-component` : `asset-large-diseño-vehiculos-detail-component`}>
              {item?.media_type === "video" ? (
                <video
                  className="active-video-banner-home-component"
                  src={`https://manager.hyundaicolombia.co/${item?.media?.url}`}
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              ) : (
                <img src={`https://manager.hyundaicolombia.co/${item?.format !== "wide" ? item?.media?.url : item?.media?.url}`} alt={item?.media?.url} />
              )}
            </div>
            <div className={item?.format !== "wide" ? `text-small-diseño-vehiculos-detail-component` : `text-large-diseño-vehiculos-detail-component`}>
              <div className={item?.format !== "wide" ? `title-text-small-diseño-vehiculos-detail-component` : `title-text-large-diseño-vehiculos-detail-component`}>
                {item?.title}
              </div>
              <div className={item?.format !== "wide" ? `description-text-small-diseño-vehiculos-detail-component` : `description-text-large-diseño-vehiculos-detail-component`}>
                {item?.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
);

export default DiseñoVehiculosComponent;
